function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { deepExtend } from "../../../../Utils/Utils";
export var Shape = /*#__PURE__*/function () {
  function Shape() {
    _classCallCheck(this, Shape);

    this.options = {};
    this.type = "circle";
  }

  _createClass(Shape, [{
    key: "image",
    get: function get() {
      var _a;

      return (_a = this.options["image"]) !== null && _a !== void 0 ? _a : this.options["images"];
    },
    set: function set(value) {
      this.options["image"] = value;
      this.options["images"] = value;
    }
  }, {
    key: "custom",
    get: function get() {
      return this.options;
    },
    set: function set(value) {
      this.options = value;
    }
  }, {
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(value) {
      this.image = value;
    }
  }, {
    key: "stroke",
    get: function get() {
      return [];
    },
    set: function set(_value) {}
  }, {
    key: "character",
    get: function get() {
      var _a;

      return (_a = this.options["character"]) !== null && _a !== void 0 ? _a : this.options["char"];
    },
    set: function set(value) {
      this.options["character"] = value;
      this.options["char"] = value;
    }
  }, {
    key: "polygon",
    get: function get() {
      var _a;

      return (_a = this.options["polygon"]) !== null && _a !== void 0 ? _a : this.options["star"];
    },
    set: function set(value) {
      this.options["polygon"] = value;
      this.options["star"] = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (data === undefined) {
        return;
      }

      var options = (_a = data.options) !== null && _a !== void 0 ? _a : data.custom;

      if (options !== undefined) {
        for (var shape in options) {
          var item = options[shape];

          if (item !== undefined) {
            this.options[shape] = deepExtend((_b = this.options[shape]) !== null && _b !== void 0 ? _b : {}, item);
          }
        }
      }

      this.loadShape(data.character, "character", "char", true);
      this.loadShape(data.polygon, "polygon", "star", false);
      this.loadShape((_c = data.image) !== null && _c !== void 0 ? _c : data.images, "image", "images", true);

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }, {
    key: "loadShape",
    value: function loadShape(item, mainKey, altKey, altOverride) {
      var _a, _b, _c, _d;

      if (item === undefined) {
        return;
      }

      if (item instanceof Array) {
        if (!(this.options[mainKey] instanceof Array)) {
          this.options[mainKey] = [];

          if (!this.options[altKey] || altOverride) {
            this.options[altKey] = [];
          }
        }

        this.options[mainKey] = deepExtend((_a = this.options[mainKey]) !== null && _a !== void 0 ? _a : [], item);

        if (!this.options[altKey] || altOverride) {
          this.options[altKey] = deepExtend((_b = this.options[altKey]) !== null && _b !== void 0 ? _b : [], item);
        }
      } else {
        if (this.options[mainKey] instanceof Array) {
          this.options[mainKey] = {};

          if (!this.options[altKey] || altOverride) {
            this.options[altKey] = {};
          }
        }

        this.options[mainKey] = deepExtend((_c = this.options[mainKey]) !== null && _c !== void 0 ? _c : {}, item);

        if (!this.options[altKey] || altOverride) {
          this.options[altKey] = deepExtend((_d = this.options[altKey]) !== null && _d !== void 0 ? _d : {}, item);
        }
      }
    }
  }]);

  return Shape;
}();